/* eslint-disable @typescript-eslint/naming-convention */

export enum Sprites {
    tile_fog = 'tile_fog',

    tile_lumber_empty = 'tile_lumber_empty',
    tile_brick_empty = 'tile_brick_empty',
    tile_wool_empty = 'tile_wool_empty',
    tile_grain_empty = 'tile_grain_empty',
    tile_ore_empty = 'tile_ore_empty',
    tile_desert_empty = 'tile_desert_empty',
    tile_gold_empty = 'tile_gold_empty',

    tile_lumber_side = 'tile_lumber_side',
    tile_brick_side = 'tile_brick_side',
    tile_wool_side = 'tile_wool_side',
    tile_grain_side = 'tile_grain_side',
    tile_ore_side = 'tile_ore_side',
    tile_desert_side = 'tile_desert_side',
    tile_gold_side = 'tile_gold_side',

    ship_red_north_west = 'ship_red_north_west',
    ship_red_west = 'ship_red_west',
    ship_red_south_west = 'ship_red_south_west',
    ship_black_north_west = 'ship_black_north_west',
    ship_black_west = 'ship_black_west',
    ship_black_south_west = 'ship_black_south_west',
    ship_blue_north_west = 'ship_blue_north_west',
    ship_blue_west = 'ship_blue_west',
    ship_blue_south_west = 'ship_blue_south_west',
    ship_bronze_north_west = 'ship_bronze_north_west',
    ship_bronze_west = 'ship_bronze_west',
    ship_bronze_south_west = 'ship_bronze_south_west',
    ship_gold_north_west = 'ship_gold_north_west',
    ship_gold_west = 'ship_gold_west',
    ship_gold_south_west = 'ship_gold_south_west',
    ship_green_north_west = 'ship_green_north_west',
    ship_green_west = 'ship_green_west',
    ship_green_south_west = 'ship_green_south_west',
    ship_mysticblue_north_west = 'ship_mysticblue_north_west',
    ship_mysticblue_west = 'ship_mysticblue_west',
    ship_mysticblue_south_west = 'ship_mysticblue_south_west',
    ship_orange_north_west = 'ship_orange_north_west',
    ship_orange_west = 'ship_orange_west',
    ship_orange_south_west = 'ship_orange_south_west',
    ship_purple_north_west = 'ship_purple_north_west',
    ship_purple_west = 'ship_purple_west',
    ship_purple_south_west = 'ship_purple_south_west',
    ship_silver_north_west = 'ship_silver_north_west',
    ship_silver_west = 'ship_silver_west',
    ship_silver_south_west = 'ship_silver_south_west',
    ship_white_north_west = 'ship_white_north_west',
    ship_white_west = 'ship_white_west',
    ship_white_south_west = 'ship_white_south_west',
    ship_pink_north_west = 'ship_pink_north_west',
    ship_pink_west = 'ship_pink_west',
    ship_pink_south_west = 'ship_pink_south_west',
    ship_highlight_north_west = 'ship_highlight_north_west',
    ship_highlight_west = 'ship_highlight_west',
    ship_highlight_south_west = 'ship_highlight_south_west',

    ship_move_black = 'ship_move_black',
    ship_move_blue = 'ship_move_blue',
    ship_move_bronze = 'ship_move_bronze',
    ship_move_gold = 'ship_move_gold',
    ship_move_green = 'ship_move_green',
    ship_move_mysticblue = 'ship_move_mysticblue',
    ship_move_orange = 'ship_move_orange',
    ship_move_purple = 'ship_move_purple',
    ship_move_red = 'ship_move_red',
    ship_move_silver = 'ship_move_silver',
    ship_move_white = 'ship_move_white',
    ship_move_pink = 'ship_move_pink',

    // All shore tiles start with TopRight as the first location of shore
    tile_sea = 'tile_sea',
    tile_shore_1 = 'tile_shore_1',
    tile_shore_2_sswwww = 'tile_shore_2_sswwww',
    tile_shore_2_swswww = 'tile_shore_2_swswww',
    tile_shore_2_swwsww = 'tile_shore_2_swwsww',
    tile_shore_3_ssswww = 'tile_shore_3_ssswww',
    tile_shore_3_sswwsw = 'tile_shore_3_sswwsw',
    tile_shore_3_sswsww = 'tile_shore_3_sswsww',
    tile_shore_3_swswsw = 'tile_shore_3_swswsw',
    tile_shore_4_ssssww = 'tile_shore_4_ssssww',
    tile_shore_4_ssswsw = 'tile_shore_4_ssswsw',
    tile_shore_4_sswssw = 'tile_shore_4_sswssw',
    tile_shore_5 = 'tile_shore_5',
    tile_shore_6 = 'tile_shore_6',

    prob_2 = 'prob_2',
    prob_3 = 'prob_3',
    prob_4 = 'prob_4',
    prob_5 = 'prob_5',
    prob_6 = 'prob_6',
    prob_8 = 'prob_8',
    prob_9 = 'prob_9',
    prob_10 = 'prob_10',
    prob_11 = 'prob_11',
    prob_12 = 'prob_12',

    icon_colonist_coin = 'icon_colonist_coin',
    icon_robber = 'icon_robber',
    icon_robber_santa = 'icon_robber_santa',
    icon_robber_lunar = 'icon_robber_lunar',
    icon_robber_cupid = 'icon_robber_cupid',
    icon_robber_tie = 'icon_robber_tie',
    icon_hourglass = 'icon_hourglass',
    icon_bot = 'icon_bot',
    icon_pencil = 'icon_pencil',
    icon_players = 'icon_players',
    icon_trade_bank_check = 'icon_trade_bank_check',
    icon_trade_opponents_check = 'icon_trade_opponents_check',

    icon_merchant_black = 'icon_merchant_black',
    icon_merchant_blue = 'icon_merchant_blue',
    icon_merchant_bronze = 'icon_merchant_bronze',
    icon_merchant_gold = 'icon_merchant_gold',
    icon_merchant_green = 'icon_merchant_green',
    icon_merchant_mysticblue = 'icon_merchant_mysticblue',
    icon_merchant_orange = 'icon_merchant_orange',
    icon_merchant_purple = 'icon_merchant_purple',
    icon_merchant_red = 'icon_merchant_red',
    icon_merchant_silver = 'icon_merchant_silver',
    icon_merchant_white = 'icon_merchant_white',
    icon_merchant_pink = 'icon_merchant_pink',

    city_white = 'city_white',
    city_blue = 'city_blue',
    city_red = 'city_red',
    city_orange = 'city_orange',
    city_green = 'city_green',
    city_gold = 'city_gold',
    city_silver = 'city_silver',
    city_bronze = 'city_bronze',
    city_purple = 'city_purple',
    city_black = 'city_black',
    city_mysticblue = 'city_mysticblue',
    city_pink = 'city_pink',

    city_destroyed_white = 'city_destroyed_white',
    city_destroyed_blue = 'city_destroyed_blue',
    city_destroyed_red = 'city_destroyed_red',
    city_destroyed_orange = 'city_destroyed_orange',
    city_destroyed_green = 'city_destroyed_green',
    city_destroyed_gold = 'city_destroyed_gold',
    city_destroyed_silver = 'city_destroyed_silver',
    city_destroyed_bronze = 'city_destroyed_bronze',
    city_destroyed_purple = 'city_destroyed_purple',
    city_destroyed_black = 'city_destroyed_black',
    city_destroyed_mysticblue = 'city_destroyed_mysticblue',
    city_destroyed_pink = 'city_destroyed_pink',

    city_wall_white = 'city_wall_white',
    city_wall_blue = 'city_wall_blue',
    city_wall_red = 'city_wall_red',
    city_wall_orange = 'city_wall_orange',
    city_wall_green = 'city_wall_green',
    city_wall_gold = 'city_wall_gold',
    city_wall_silver = 'city_wall_silver',
    city_wall_bronze = 'city_wall_bronze',
    city_wall_purple = 'city_wall_purple',
    city_wall_black = 'city_wall_black',
    city_wall_mysticblue = 'city_wall_mysticblue',
    city_wall_pink = 'city_wall_pink',

    road_white = 'road_white',
    road_blue = 'road_blue',
    road_red = 'road_red',
    road_orange = 'road_orange',
    road_green = 'road_green',
    road_gold = 'road_gold',
    road_silver = 'road_silver',
    road_bronze = 'road_bronze',
    road_purple = 'road_purple',
    road_black = 'road_black',
    road_mysticblue = 'road_mysticblue',
    road_pink = 'road_pink',
    road_highlight = 'road_highlight',

    settlement_white = 'settlement_white',
    settlement_blue = 'settlement_blue',
    settlement_red = 'settlement_red',
    settlement_orange = 'settlement_orange',
    settlement_green = 'settlement_green',
    settlement_gold = 'settlement_gold',
    settlement_silver = 'settlement_silver',
    settlement_bronze = 'settlement_bronze',
    settlement_purple = 'settlement_purple',
    settlement_black = 'settlement_black',
    settlement_mysticblue = 'settlement_mysticblue',
    settlement_pink = 'settlement_pink',

    knight_level1_active_black = 'knight_level1_active_black',
    knight_level1_active_blue = 'knight_level1_active_blue',
    knight_level1_active_bronze = 'knight_level1_active_bronze',
    knight_level1_active_gold = 'knight_level1_active_gold',
    knight_level1_active_green = 'knight_level1_active_green',
    knight_level1_active_mysticblue = 'knight_level1_active_mysticblue',
    knight_level1_active_orange = 'knight_level1_active_orange',
    knight_level1_active_purple = 'knight_level1_active_purple',
    knight_level1_active_red = 'knight_level1_active_red',
    knight_level1_active_silver = 'knight_level1_active_silver',
    knight_level1_active_white = 'knight_level1_active_white',
    knight_level1_active_pink = 'knight_level1_active_pink',

    knight_level2_active_black = 'knight_level2_active_black',
    knight_level2_active_blue = 'knight_level2_active_blue',
    knight_level2_active_bronze = 'knight_level2_active_bronze',
    knight_level2_active_gold = 'knight_level2_active_gold',
    knight_level2_active_green = 'knight_level2_active_green',
    knight_level2_active_mysticblue = 'knight_level2_active_mysticblue',
    knight_level2_active_orange = 'knight_level2_active_orange',
    knight_level2_active_purple = 'knight_level2_active_purple',
    knight_level2_active_red = 'knight_level2_active_red',
    knight_level2_active_silver = 'knight_level2_active_silver',
    knight_level2_active_white = 'knight_level2_active_white',
    knight_level2_active_pink = 'knight_level2_active_pink',

    knight_level3_active_black = 'knight_level3_active_black',
    knight_level3_active_blue = 'knight_level3_active_blue',
    knight_level3_active_bronze = 'knight_level3_active_bronze',
    knight_level3_active_gold = 'knight_level3_active_gold',
    knight_level3_active_green = 'knight_level3_active_green',
    knight_level3_active_mysticblue = 'knight_level3_active_mysticblue',
    knight_level3_active_orange = 'knight_level3_active_orange',
    knight_level3_active_purple = 'knight_level3_active_purple',
    knight_level3_active_red = 'knight_level3_active_red',
    knight_level3_active_silver = 'knight_level3_active_silver',
    knight_level3_active_white = 'knight_level3_active_white',
    knight_level3_active_pink = 'knight_level3_active_pink',

    knight_level1_inactive_black = 'knight_level1_inactive_black',
    knight_level1_inactive_blue = 'knight_level1_inactive_blue',
    knight_level1_inactive_bronze = 'knight_level1_inactive_bronze',
    knight_level1_inactive_gold = 'knight_level1_inactive_gold',
    knight_level1_inactive_green = 'knight_level1_inactive_green',
    knight_level1_inactive_mysticblue = 'knight_level1_inactive_mysticblue',
    knight_level1_inactive_orange = 'knight_level1_inactive_orange',
    knight_level1_inactive_purple = 'knight_level1_inactive_purple',
    knight_level1_inactive_red = 'knight_level1_inactive_red',
    knight_level1_inactive_silver = 'knight_level1_inactive_silver',
    knight_level1_inactive_white = 'knight_level1_inactive_white',
    knight_level1_inactive_pink = 'knight_level1_inactive_pink',

    knight_level2_inactive_black = 'knight_level2_inactive_black',
    knight_level2_inactive_blue = 'knight_level2_inactive_blue',
    knight_level2_inactive_bronze = 'knight_level2_inactive_bronze',
    knight_level2_inactive_gold = 'knight_level2_inactive_gold',
    knight_level2_inactive_green = 'knight_level2_inactive_green',
    knight_level2_inactive_mysticblue = 'knight_level2_inactive_mysticblue',
    knight_level2_inactive_orange = 'knight_level2_inactive_orange',
    knight_level2_inactive_purple = 'knight_level2_inactive_purple',
    knight_level2_inactive_red = 'knight_level2_inactive_red',
    knight_level2_inactive_silver = 'knight_level2_inactive_silver',
    knight_level2_inactive_white = 'knight_level2_inactive_white',
    knight_level2_inactive_pink = 'knight_level2_inactive_pink',

    knight_level3_inactive_black = 'knight_level3_inactive_black',
    knight_level3_inactive_blue = 'knight_level3_inactive_blue',
    knight_level3_inactive_bronze = 'knight_level3_inactive_bronze',
    knight_level3_inactive_gold = 'knight_level3_inactive_gold',
    knight_level3_inactive_green = 'knight_level3_inactive_green',
    knight_level3_inactive_mysticblue = 'knight_level3_inactive_mysticblue',
    knight_level3_inactive_orange = 'knight_level3_inactive_orange',
    knight_level3_inactive_purple = 'knight_level3_inactive_purple',
    knight_level3_inactive_red = 'knight_level3_inactive_red',
    knight_level3_inactive_silver = 'knight_level3_inactive_silver',
    knight_level3_inactive_white = 'knight_level3_inactive_white',
    knight_level3_inactive_pink = 'knight_level3_inactive_pink',

    knight_move_black = 'knight_move_black',
    knight_move_blue = 'knight_move_blue',
    knight_move_bronze = 'knight_move_bronze',
    knight_move_gold = 'knight_move_gold',
    knight_move_green = 'knight_move_green',
    knight_move_mysticblue = 'knight_move_mysticblue',
    knight_move_orange = 'knight_move_orange',
    knight_move_purple = 'knight_move_purple',
    knight_move_red = 'knight_move_red',
    knight_move_silver = 'knight_move_silver',
    knight_move_white = 'knight_move_white',
    knight_move_pink = 'knight_move_pink',

    knight_active_level1 = 'knight_active_level1',

    metropolis_science = 'metropolis_science',
    metropolis_trade = 'metropolis_trade',
    metropolis_politics = 'metropolis_politics',

    port_pier = 'port_pier',
    port = 'port',
    port_lumber = 'port_lumber',
    port_brick = 'port_brick',
    port_wool = 'port_wool',
    port_grain = 'port_grain',
    port_ore = 'port_ore',
    port_highlight = 'port_highlight',

    card_lumber = 'card_lumber',
    card_brick = 'card_brick',
    card_wool = 'card_wool',
    card_grain = 'card_grain',
    card_ore = 'card_ore',
    card_vp = 'card_vp',
    card_knight = 'card_knight',
    card_yearofplenty = 'card_yearofplenty',
    card_monopoly = 'card_monopoly',
    card_roadbuilding = 'card_roadbuilding',
    card_badge_background = 'card_badge_background',
    card_paper = 'card_paper',
    card_cloth = 'card_cloth',
    card_coin = 'card_coin',

    card_overlay_blue = 'card_overlay_blue',
    card_overlay_black = 'card_overlay_black',
    card_overlay_white = 'card_overlay_white',

    card_progress_politics_back = 'card_progress_politics_back',
    card_progress_politics_bishop = 'card_progress_politics_bishop',
    card_progress_politics_constitution = 'card_progress_politics_constitution',
    card_progress_politics_deserter = 'card_progress_politics_deserter',
    card_progress_politics_diplomat = 'card_progress_politics_diplomat',
    card_progress_politics_intrigue = 'card_progress_politics_intrigue',
    card_progress_politics_saboteur = 'card_progress_politics_saboteur',
    card_progress_politics_spy = 'card_progress_politics_spy',
    card_progress_politics_warlord = 'card_progress_politics_warlord',
    card_progress_politics_wedding = 'card_progress_politics_wedding',
    card_progress_science_back = 'card_progress_science_back',
    card_progress_science_alchemist = 'card_progress_science_alchemist',
    card_progress_science_crane = 'card_progress_science_crane',
    card_progress_science_engineer = 'card_progress_science_engineer',
    card_progress_science_inventor = 'card_progress_science_inventor',
    card_progress_science_irrigation = 'card_progress_science_irrigation',
    card_progress_science_medicine = 'card_progress_science_medicine',
    card_progress_science_mining = 'card_progress_science_mining',
    card_progress_science_printer = 'card_progress_science_printer',
    card_progress_science_road_building = 'card_progress_science_road_building',
    card_progress_science_smith = 'card_progress_science_smith',
    card_progress_trade_back = 'card_progress_trade_back',
    card_progress_trade_commercial_harbor = 'card_progress_trade_commercial_harbor',
    card_progress_trade_master_merchant = 'card_progress_trade_master_merchant',
    card_progress_trade_merchant_fleet = 'card_progress_trade_merchant_fleet',
    card_progress_trade_merchant = 'card_progress_trade_merchant',
    card_progress_trade_resource_monopoly = 'card_progress_trade_resource_monopoly',
    card_progress_trade_commodity_monopoly = 'card_progress_trade_commodity_monopoly',

    icon_player = 'icon_player',
    icon_player_loggedin = 'icon_player_loggedin',
    icon_settler = 'icon_settler',
    icon_colonist = 'icon_colonist',
    icon_founder = 'icon_founder',
    icon_christmas_hat = 'icon_christmas_hat',
    icon_pirate_ship = 'icon_pirate_ship',
    icon_discard_resource_cards = 'icon_discard_resource_cards',
    icon_discard_progress_cards = 'icon_discard_progress_cards',
    icon_aqueduct = 'icon_aqueduct',
    icon_fortress = 'icon_fortress',
    icon_tradehouse = 'icon_tradehouse',

    icon_lock_on = 'icon_lock_on',
    icon_lock_off = 'icon_lock_off',
    icon_trade_arrow_red = 'icon_trade_arrow_red',
    icon_trade_arrow_green = 'icon_trade_arrow_green',
    icon_trophy = 'icon_trophy',
    icon_chit = 'icon_chit',
    icon_check = 'icon_check',
    icon_x = 'icon_x',
    icon_trade = 'icon_trade',
    card_devcardback = 'card_devcardback',
    icon_pass_turn = 'icon_pass_turn',
    icon_highlight_circle = 'icon_highlight_circle',
    icon_highlight_circle_white = 'icon_highlight_circle_white',
    icon_highlight_square_yellow = 'icon_highlight_square_yellow',
    icon_arrow_player_profile = 'icon_arrow_player_profile',
    icon_arrow_player_profile_white = 'icon_arrow_player_profile_white',
    icon_beginner_hint = 'icon_beginner_hint',

    player_bg_black = 'player_bg_black',
    player_bg_blue = 'player_bg_blue',
    player_bg_bronze = 'player_bg_bronze',
    player_bg_gold = 'player_bg_gold',
    player_bg_green = 'player_bg_green',
    player_bg_orange = 'player_bg_orange',
    player_bg_purple = 'player_bg_purple',
    player_bg_red = 'player_bg_red',
    player_bg_silver = 'player_bg_silver',
    player_bg_mysticblue = 'player_bg_mysticblue',
    player_bg_white = 'player_bg_white',
    player_bg_pink = 'player_bg_pink',

    bg_section = 'bg_section',
    bg_section_dark = 'bg_section_dark',
    bg_button = 'bg_button',

    button_badge_background_white = 'button_badge_background_white',
    button_badge_background_blue = 'button_badge_background_blue',
    button_badge_background_red = 'button_badge_background_red',
    button_badge_background_orange = 'button_badge_background_orange',
    button_badge_background_green = 'button_badge_background_green',
    button_badge_background_gold = 'button_badge_background_gold',
    button_badge_background_silver = 'button_badge_background_silver',
    button_badge_background_bronze = 'button_badge_background_bronze',
    button_badge_background_purple = 'button_badge_background_purple',
    button_badge_background_black = 'button_badge_background_black',
    button_badge_background_mysticblue = 'button_badge_background_mysticblue',
    button_badge_background_pink = 'button_badge_background_pink',

    ribbon_large = 'ribbon_large',
    ribbon_long = 'ribbon_long',

    icon_beginner_hint_initial_placement = 'icon_beginner_hint_initial_placement',

    icon_sheep = 'icon_sheep',

    empty = ''
}
